module.exports = __webpack_public_path__ + "img/mcdonalds.bac48e9b.jpg";